/**
 * SubTitle.tsx — Renders `sectionData.subTitle` as an `<h3>` heading.
 *
 * JSON trigger: `uiCompType.method: "renderSubTitle"`
 * Also used by `Panel` for the `subTitle` key.
 *
 * Delegates to `renderText(sectionData.subTitle, 'subTitle', {}, props, 'h3')`.
 * Full text directive support is available via the `transformTextToHtml` pipeline.
 *
 * **Style slots:** `uiCompType.styles`, `uiCompType.className`.
 */
import React from "react";
import { SectionData, ComponentRenderProps } from "./index";
import { renderText } from "./index";

const SubTitle = ({ sectionData, props }: { sectionData: SectionData, props: ComponentRenderProps }): JSX.Element | null => {
    return renderText(sectionData.subTitle || "" , "subTitle", sectionData.uiCompType, props , 'h3') || null;
};

export default SubTitle;
